module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEeSURBVHgB7VFLSgNBEK3u+RiiaRoER0zEcSciQ7zBuPMK3iI3EE+hW5eujCtxpZ4gIYK4c0AiiSsdE5jMMOlU5bMJEzJZZdMPCrqpqveK9wA0NDRY3kG5e+Smlv1M7ySJz6LOR5Bnj+cZ2qqc+KlpN0CBS2Wh0Gb5uJpnd6mAqHiXDDhdLpH8FkDVSYQzsyHKXm3ZvrGoIaUrre2DazRxTKIArnrtVi0Of+5s4TD01sfeeUE4MAi7rysJkN/DQvGRCPD7C6m66H2/3cz6cdh9sUrOH5v0/Q2xUy3yvaco6kTzXJkhl/a9z6nfQZJyDLQZZM1RDhzMe2RxsYL/r9bh/ExmBkrBA2rXjT4/XURO6LffmwYeQIfAEDQ0NNaFETFXVuNg4XDmAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dropdown_arrow_up.png
// module id = 1645
// module chunks = 0